module.exports = __webpack_public_path__ + "static/media/kraken-sushi-bar-identidade-visual-768x591.1683c867.jpg";